const getQueryString = (search = window.location.search, name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
  let r = search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

export default getQueryString
